<template>
  <v-container class="pa-4 marginToFooter">
    <v-layout
      row
      wrap
      style="align-items: center"
    >
      <v-btn
        flat
        icon
        color="primary"
        style="width: 20px"
        @click="toggleCampaignDialog"
      >
        <v-icon>
          $vuetify.icons.arrowLeftIcon
        </v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        color="primary"
        style="text-transform: none"
        @click="$router.push(`/contatos`)"
      >
        Voltar
      </v-btn>
    </v-layout>
    <v-layout>
      <TitleChip title="Potencial Cliente" />
    </v-layout>
    <v-layout class="animated fadeIn delay-1s">
      <v-flex xs12>
        <v-form
          ref="form"
          class="potential-client-form"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm12
              md6
              lg6
              :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
            >
              <v-text-field
                v-model="person.nome"
                label="Nome"
                :rules="[(v) => !!v || 'Campo requerido!']"
                clearable
                :disabled="isRegistered"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              lg6
            >
              <v-text-field
                v-model="person.sobrenome"
                label="Sobrenome"
                :rules="[(v) => !!v || 'Campo requerido!']"
                clearable
                :disabled="isRegistered"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              lg6
              :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
            >
              <v-text-field
                v-model="person.celular"
                label="Celular"
                mask="(##) #####-####"
                :error-messages="phoneErrorMessage"
                clearable
                :disabled="isRegistered"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              lg6
            >
              <v-text-field
                v-model="person.email"
                label="Email"
                :error-messages="mailErrorMessage"
                clearable
                :disabled="isRegistered"
              />
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              lg6
            >
              <v-text-field
                v-model="person.cpf"
                mask="###.###.###-##"
                label="CPF"
                :error-messages="cpfErrorMessage"
                clearable
                :disabled="isRegistered"
              />
            </v-flex>
          </v-layout>
          <v-alert
            v-model="alert"
            class="animated fadeIn delay-0.5s"
            :color="alertColor"
            :icon="alertIcon"
            outline
          >
            <div v-html="alertMessage" />
          </v-alert>
          <div
            v-if="loading"
            class="text-xs-center mt-3"
          >
            <v-progress-circular
              :size="50"
              :width="7"
              color="#primary"
              indeterminate
            />
          </div>

          <v-layout
            v-show="!loading"
            row
            wrap
            justify-center
          >
            <div class="actions-btn-div">
              <v-btn
                color="primary"
                outline
                class="actions-btn text-capitalize"
                @click="reset"
              >
                Limpar
              </v-btn>

              <v-btn
                color="primary"
                class="actions-btn text-capitalize ml-2"
                style="margin: 0"
                @click="submit"
              >
                Cadastrar
              </v-btn>
            </div>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="createTask"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-text v-if="contato">
          <v-flex>
            <Notifications :person="contato" />
          </v-flex>
        </v-card-text>
        <v-card-actions class="animated fadeIn delay-0.5s">
          <v-spacer />
          <v-btn
            round
            small
            outline
            flat="flat"
            class="text-lowercase"
            @click="createTask = false"
          >
            fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { APIService } from '@/resources/campanha.js';
import format from 'date-fns/format';
import { EventBus } from '@/event-bus.js';
import emailSanitizer from '@/resources/sanitizers/email.js';
import phoneSanitizer from '@/resources/sanitizers/phone.js';
import cpfSanitizer from '@/resources/sanitizers/cpf.js';
import nameSanitizer from '@/resources/sanitizers/name.js';

const api = new APIService();

export default {
  filters: {
    formattedDate: (item) => (item ? format(item, 'DD/MM/YYYY') : 'Não Informado'),
  },
  data() {
    return {
      notRegistered: false,
      alertIcon: '',
      alertColor: '',
      alertMessage: '',
      alert: false,
      contato: null,
      person: {},
      loading: false,
      mailErrorMessage: [],
      phoneErrorMessage: [],
      cpfErrorMessage: [],
      isRegistered: false,
      createTask: false,
    };
  },

  methods: {
    reset() {
      this.$refs.form.reset();
    },
    novoCadastro() {
      this.isRegistered = false;
      this.alert = false;
      this.notRegistered = true;
      this.reset();
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const newPerson = { ...this.person };
        const sanitezedName = await nameSanitizer(this.person.nome);
        const sanitezedSurname = await nameSanitizer(this.person.sobrenome);

        const sanitizedPhone = await phoneSanitizer(this.person.celular);
        if (newPerson.celular) {
          newPerson.celular = sanitizedPhone;
          !newPerson.celular.valid
            ? (this.phoneErrorMessage = ['Telefone inválido'])
            : (this.phoneErrorMessage = []);
        } else {
          this.phoneErrorMessage = ['Campo requerido'];
        }

        if (newPerson.email) {
          const sanitezedMail = await emailSanitizer(this.person.email);
          newPerson.email = sanitezedMail;
          !newPerson.email.valid
            ? (this.mailErrorMessage = ['E-mail inválido'])
            : (this.mailErrorMessage = []);
        } else {
          newPerson.email = null;
        }

        if (newPerson.cpf) {
          const sanitezedCpf = await cpfSanitizer(this.person.cpf);
          newPerson.cpf = sanitezedCpf;
          !newPerson.cpf.valid
            ? (this.cpfErrorMessage = ['CPF inválido'])
            : (this.cpfErrorMessage = []);
        } else {
          newPerson.cpf = null;
        }

        newPerson.nome = sanitezedName.value;
        newPerson.sobrenome = sanitezedSurname.value;
        newPerson.canal = 'OFFLINE';
        newPerson.situacao = 'LEAD';
        newPerson.seller = this.$store.state.profile.name;
        newPerson.sellerId = this.$store.state.profile.id;
        newPerson.customerId = this.$store.state.customer.id;
        newPerson.quantidadePedidos = 0;
        newPerson.criacao = new Date();
        newPerson.categoriasPreferidas = ['-'];

        const uuidv1 = require('uuid/v1');
        newPerson.idERP = uuidv1();
        if (
          this.phoneErrorMessage.length == 0
          && this.mailErrorMessage
          && this.cpfErrorMessage
        ) {
          this.loading = true;
          this.notRegistered = false;
          api.createIfPhoneNotExists(newPerson).then(async (res) => {
            if (
              res.data.assignedSeller == newPerson.seller
              || (res.data.seller == newPerson.seller && !res.data.assignedSeller)
            ) {
              if (format(res.data.criacao, 'DD/MM/YYYY HH:MM:SS') != format(newPerson.criacao, 'DD/MM/YYYY HH:MM:SS')) {
                this.alertIcon = 'check_circle',
                this.alertColor = 'success',
                this.alertMessage = `O número informado já está registrado na sua agenda com o nome de <strong>${res.data.nome}</strong>, sua situação é <strong>${res.data.situacao}</strong>.`,
                this.alert = true;
                this.contato = res.data;
              } else {
                this.emitSnackBar();
                this.contato = res.data;
                this.$router.push('/contatos');
              }
            } else if (res.data.assignedSeller) {
              this.alertIcon = 'fas fa-exclamation-circle',
              this.alertColor = 'warning',
              this.alertMessage = `O número informado é um cliente da marca e está registrado pelo vendedor <strong>${res.data.assignedSeller}</strong>. Entre em contato com seu Gerente.`,
              this.alert = true;
              this.notRegistered = true;
            } else {
              this.alertIcon = 'fas fa-exclamation-circle',
              this.alertColor = 'warning',
              this.alertMessage = `O número informado é um cliente da marca e está registrado pelo vendedor <strong>${res.data.seller}</strong>. Entre em contato com seu Gerente.`,
              this.alert = true;
              this.notRegistered = true;
            }
            await this.$store.dispatch('carregarListaContatos', {
              user: this.$auth.user,
              force: true,
            }, 'LEAD');
            this.loading = false;
            this.isRegistered = true;
          });
        }
      }
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Lead cadastrado com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}
.actions-btn-div {
  margin-top: 24px;
}
.actions-btn {
  text-align: justify;
  padding-left: 25px !important;
  padding-right: 25px !important;
  width: 137px;
  height: 46px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 14px;
  border-radius: 7px !important;
  text-transform: none;
}
.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}

.marginToFooter {
  margin-bottom: 75px;
}
::v-deep .v-input .v-label {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: #140C22;
}
</style>
